<template>
  <div>
    <basic-container>
      <el-form :model="goodsForm" label-width="110px" class="goods-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="产品名称">
              <el-input v-model="goodsForm.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品价格">
              <el-input v-model="goodsForm.price" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采购价">
              <el-input v-model="goodsForm.purchasePrice" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平方用量">
              <el-input v-model="goodsForm.areaUsage" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否参与计算">
              <el-input v-model="splitFlagText" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分组">
              <el-input v-model="goodsForm.costGrouping" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="材料类型">
              <el-input v-model="materialTypeText" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最低平方用料（元/平方）">
              <el-input v-model="goodsForm.areaCost" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平方用料上限（元/平方）">
              <el-input v-model="goodsForm.areaCostCap" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="form-actions">
        <el-button type="primary" size="small" @click="goBack" icon="el-icon-back">返回上一页</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { getGoodsForm } from "@/api/work/waterProject/purWaterGoods";

export default {
  computed: {
    splitFlagText() {
      if (this.goodsForm.splitFlag === 0) return '否';
      if (this.goodsForm.splitFlag === 1) return '是';
      return '';
    },
    materialTypeText() {
      if (this.goodsForm.materialType === 0) return '其它';
      if (this.goodsForm.materialType === 1) return '刚性';
      if (this.goodsForm.materialType === 2) return '柔性';
      return '';
    }
  },
  data() {
    return {
      goodsForm: {
        name: '',
        id: '',
        price: '',
        purchasePrice: '',
        areaUsage: '',
        filters: []
      },
      goodsFormData: [],
      isPas: false,
      dynamicForm: {
        formName: '',
        formType: ''
      },
      dynamicFormData: []
    };
  },
  created() {
    const goodsId = this.$route.query.GoodsId;
    if (goodsId) {
      this.fetchGoodsData(goodsId);
    }
  },
  methods: {
    fetchGoodsData(goodsId) {
      getGoodsForm(goodsId).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.goodsForm = data;
          if (data.filters) {
            this.goodsFormData = data.filters.map(filter => ({ ...filter }));
          }
          if (data.dynamicFormRequest && data.dynamicFormRequest.fields) {
            this.dynamicFormData = data.dynamicFormRequest.fields.map(field => ({
              fieldName: field.fieldName,
              inputType: field.inputType,
              dataSource: field.dataSource,
              isNull: field.isNull,
              sort: field.sort
            }));
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    goBack() {
      let item = {
        close: true,
        label: "查看净水产品",
        value: "/work/waterProject/purWaterGoods/view"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.goods-form .el-form-item {
  display: flex;
}
.goods-form .el-form-item .el-form-item__content {
  flex: 1;
}
.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 12px;
}
</style>
